/**
 * Create store system divecePatch - deviceLicenseMgmt
 * 시스템 > 패치 관리 > 장비 관리 > 라이선스 패치
 *
 * @since 2018-11-08
 * @author devp018
 * @modify jupil.Go <devp018>
 */

import {i18n} from '~/plugins/i18n'
import {getCodeJsonRow} from '~/utils/device-common'
import {CommonApiPrefix as cmnApiPrefix, SystemApiPrefix as apiPrefix} from '~/utils/restApi'

export const state = () => ({
  apiUrl: {
    ngf: `${apiPrefix}/patch/device/license-patch`, // NGF 라이선스 패치 API
    ips: `${apiPrefix}/patch/device/license-patch-ips`, // IPS 라이선스 패치 API
    ads: `${apiPrefix}/patch/device/license-patch-ads`, // IPS 라이선스 패치 API
    wips: `${apiPrefix}/patch/device/license-patch-wips` // IPS 라이선스 패치 API
  },
  device_id: void 0,
  patchDeviceList: [], // 장비 목록
  upLoadFile: void 0,
  deviceTypeOptions: [],
  modelTypeOptions: [],
  errorMessage: null
})

export const mutations = {
  setErrorMessage (state, data) {
    state.errorMessage = data.msg
    const msg = {
      error: data.msg
    }
    state.errorMessage = msg
  },
  getDeviceTypeOptions (state) {
    // 장비 타입 (0: 장비 그룹, 1: Stand-Alone 장비, 2: Master 장비, 3: Slave 장비, 4: Prism Master, 5: Prism Slave)
    state.deviceTypeOptions = _.map(getCodeJsonRow('device_type'), (item) => {
      return { value: Number(item.key), label: item.val }
    })
  },
  getModelTypeOptions (state) {
    // 장비 모델 유형 (9: MF2, 10: MFI, 11: MFD, 12: MF2 AE, 10: Black Swan)
    state.modelTypeOptions = _.map(getCodeJsonRow('device_model_type'), (item) => {
      return { value: Number(item.key), label: item.val }
    })
  },
  clearPatchDeviceData (state) {
    state.patchDeviceList = []
  },
  // 패치 대상 장비 목록 설정
  setPatchDeviceData (state, data) {
    state.patchDeviceList = data
  },
  setDeviceID (state, data) {
    state.device_id = data
  },
  // 파일 업로드
  fileUpload (state, {file}) {
    state.upLoadFile = file
  }
}

export const actions = {
  // 파일 업로드
  async fileUpload ({commit, state}, {formData}) {
    const {code, result} = await this.$axios.$post(`${cmnApiPrefix}/file/import`, formData)

    if (code === 'ok') {
      commit('fileUpload', result)
      return true
    }
    commit('setErrorMessage', result)
    return false
  },
  // 패치 대상 장비 목록 조회
  async getDevicePatchData ({commit, state}, { type = 'ngf', id = 0 }) {
    const {code, result} = await this.$axios.$get(`${state.apiUrl[type]}/${id}`)

    if (code === 'ok') {
      commit('setPatchDeviceData', result)
    }
    return {code, result}
  },
  // 대상 장비에 패치 수행
  async setDevicePatchData ({commit, state}, { type = 'ngf' }) {
    const {code, result} = await this.$axios.$put(`${state.apiUrl[type]}/${state.device_id}`, { file_name: `${state.upLoadFile}` }, {alertMsg: i18n.t('msg.apply')})
    if (code === 'ok') {
      return true
    }
    commit('setErrorMessage', result)
    return false
  }
}

export const getters = {
}

export const strict = false
